import * as React from 'react';
import { ValidationResult, FormField } from 'sos-common/js/commonTypes';
import { ReactElement } from 'react';

export interface ChildMap {
  top?: React.ReactNode;
  conditional: React.ReactNode;
  bottom?: React.ReactNode;
}
export interface ConditionalProps {
  children: ChildMap;
  showConditional?: boolean;
  indent?: boolean;
}

export class Conditional extends React.Component<ConditionalProps, {}> {
  static defaultProps = {
    children: {},
    showConditional: false,
    indent: true
  } as ConditionalProps;

  render() {
    const { indent, showConditional, children } = this.props;
    const conditionalClass = indent ? 'indent' : '';
    const conditionalChildren = React.Children.map(children.conditional, (child: ReactElement<FormField<any>>, index) => {
      if(child.props.fieldName === undefined) return child
      return React.cloneElement(child, {
        conditionalState: showConditional
      });
    })
    
    return (
      <div>
        {children.top}
        {showConditional && (
          <div className={conditionalClass}>{conditionalChildren}</div>
        )}
        {children.bottom || null}
      </div>
    );
  }
}
